<product-search [unitTrust]="ut" [bond]="bond" [stock]="stock" [etf]="etf"
                   (query)="search($event)" (nextPage)="loadNext()" (resultClick)="openProduct($event)"
                   [searching]="searching" [results]="searchResults" [activationCount]=0>
</product-search>
<!-- article insurance dpms faq -->